import React from 'react'
import { useFormContext } from 'react-hook-form'
import Typography from '@mui/material/Typography'
import {
    IssueTypeText,
    isValidLimitedIssueType,
    PlainIssueTypeSelectProps,
    RegisteredIssueTypeSelect,
} from '../../../../components/entities/IssueType'
import { FormIssueEntity } from './AdminIssueForm'

/**
 * Id "issue" is null, show a RegisteredIssueTypeSelect. Also, if the issue type is one of
 * "Rights issue", "Non-cash issue", or "Accelerated bookbuilding", show a IssueTypeField.
 * Otherwise, show the issue type as a Typography element.
 * @param {*} issue
 */
export function IssueTypeField({
    issue,
    ...props
}: { issue: FormIssueEntity } & Omit<PlainIssueTypeSelectProps, 'fullWidth' | 'limited'>) {
    const { watch } = useFormContext()
    const type = watch('type') || issue?.type
    if (!issue || isValidLimitedIssueType(type)) {
        const limited = isValidLimitedIssueType(type)
        return <RegisteredIssueTypeSelect limited={limited} {...props} fullWidth />
    } else {
        return (
            <Typography variant='body1'>
                Typ: <IssueTypeText issueType={type} />
            </Typography>
        )
    }
}
